import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ISelectSiteGridProps {
  condensedLayout?: boolean;
}

export const SelectSiteGrid = styled.ul<ISelectSiteGridProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)} ${toRem(theme.space.xl)};
  width: 100%;
  list-style: none;

  @media (min-width: ${theme.breakpoint.small}px) {
    grid-template-columns: repeat(auto-fit, minmax(${toRem(300)}, 1fr));
  }

  ${({ condensedLayout }) =>
    condensedLayout &&
    css`
      grid-template-columns: 1fr;

      @media (min-width: ${theme.breakpoint.small}px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (min-width: ${theme.breakpoint.xlarge}px) {
        grid-template-columns: repeat(4, 1fr);
      }
    `}
`;
